
import { createTheme } from "@mui/material/styles";


const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
          borderRadius: 0,
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#004E37",
      contrastText: "#f7f9f8",
    },
    secondary: {
      main: "#5d5d5d", //'#484850'
      light: "#c1c1c1",
      dark: "#414141",
    },
    error: {
      main: "#d32f2f",
    },
  },
});

export default theme;
